export const ShowTitle = () => {
  return <p>Open Mic</p>;
};
